export const GetTimeRead = (time:number|Date, timezone:string="Europe/Stockholm") => {
    return new Date(time).toLocaleTimeString("sv-SE", {timeZone: timezone, hour: "2-digit", minute: "2-digit" })
}
export const GetDateRead = (date:number|Date, timezone:string="Europe/Stockholm") => {
    return new Date(date).toLocaleDateString("sv-SE", {timeZone: timezone})
}